(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ratiocontainer", [], factory);
	else if(typeof exports === 'object')
		exports["ratiocontainer"] = factory();
	else
		root["ratiocontainer"] = factory();
})(this, () => {
return 